import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import GridList from 'material-ui/GridList';
import GridListTile from 'material-ui/GridList/GridListTile';

import image1 from 'assets/img/coding2.jpg';

 
 const tileData = [
    {
      img: image1,
      featured: true,
    }

 ];

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: '100%',
    height: 'auto',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  }
});

 
function ImageGridOne(props) {
  const { classes } = props;

  return (
    <div className={classes.root}>
      <GridList cellHeight={150} spacing={0} className={classes.gridList}>
        {tileData.map(tile => (
          <GridListTile key={tile.img} cols={tile.featured ? 2 : 1} rows={tile.featured ? 2 : 1}>
            <img src={tile.img} alt='coding' />
          </GridListTile>
        ))}
      </GridList>
    </div>
  );
}

ImageGridOne.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ImageGridOne);


// WEBPACK FOOTER //
// ./src/views/ProjectPage/UI/ImageGridOne.jsx